import './SeparationLine.scss'; // Import the CSS file

const SmallSeparationLine = () => {
  return <div className="small-separation-line"></div>;
};

export default SmallSeparationLine;
